import { render, staticRenderFns } from "./base-modal.vue?vue&type=template&id=1fde2988&scoped=true&"
import script from "./base-modal.vue?vue&type=script&lang=js&"
export * from "./base-modal.vue?vue&type=script&lang=js&"
import style0 from "./base-modal.vue?vue&type=style&index=0&id=1fde2988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde2988",
  null
  
)

export default component.exports